let isAndroid =
  navigator.userAgent.indexOf("Android") > -1 ||
  navigator.userAgent.indexOf("Adr") > -1;
let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

// 请求队列
const requestQueue = [];
let isProcessing = false;

function processQueue() {
  console.log("requestQueue: ", JSON.parse(JSON.stringify(requestQueue)));
  if (requestQueue.length === 0 || isProcessing) return;

  isProcessing = true;
  const { name, data, callback, resolve, reject } = requestQueue.shift();

  setupWebViewJavascriptBridge((bridge) => {
    bridge.callHandler(name, data, (responseData) => {
      callback(responseData || "");
      resolve(responseData || "");

      // 处理完成后，继续处理下一个请求
      isProcessing = false;
      processQueue(); // Process next request
    });
  });

  if (name === "uploadPic") {
    // 上传前没有回调，会导致阻塞。 
    resolve();
    isProcessing = false;
    processQueue(); // Process next request
  }
}

function enqueueRequest(name, data, callback) {
  return new Promise((resolve, reject) => {
    if (callback) {
      requestQueue.push({ name, data, callback, resolve, reject });
      processQueue();
    } else {
      setupWebViewJavascriptBridge((bridge) => {
        bridge.callHandler(name, data, (responseData) => {
          callback(responseData);
        });
      });
    }
  });
}

function setupWebViewJavascriptBridge(callback) {
  if (isAndroid) {
    if (window.WebViewJavascriptBridge) {
      callback(window.WebViewJavascriptBridge);
    } else {
      document.addEventListener(
        "WebViewJavascriptBridgeReady",
        () => {
          callback(window.WebViewJavascriptBridge);
        },
        false
      );
      sessionStorage.phoneType = "android";
    }
  }

  if (isiOS) {
    if (window.WebViewJavascriptBridge) {
      return callback(window.WebViewJavascriptBridge);
    }
    if (window.WVJBCallbacks) {
      return window.WVJBCallbacks.push(callback);
    }
    window.WVJBCallbacks = [callback];
    var WVJBIframe = document.createElement("iframe");
    WVJBIframe.style.display = "none";
    WVJBIframe.src = "wvjbscheme://__BRIDGE_LOADED__";
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(() => {
      document.documentElement.removeChild(WVJBIframe);
    }, 0);
    sessionStorage.phoneType = "ios";
  }
}

// Initialize bridge on first connection
setupWebViewJavascriptBridge((bridge) => {
  if (isAndroid) {
    bridge.init((message, responseCallback) => {
      console.log(">>>>init>>>>");
      responseCallback(null);
    });
  }
});

export default {
  callHandler(name, data, callback) {
    // 需要回调的必须加入
    if (!["api", "api2", "uploadPic", "canShowStrengthVideoShare", "checkCameraPermission", "checkPhotoPermission"].includes(name)) {
      enqueueRequest(name, data);
    } else {
      enqueueRequest(name, data, callback);
    }
  },

  registerHandler(name, callback) {
    setupWebViewJavascriptBridge((bridge) => {
      bridge.registerHandler(name, (data, responseCallback) => {
        callback(data, responseCallback);
      });
    });
  },
};



// WEBPACK FOOTER //
// ./src/js/jsBridge.js